module.exports = __webpack_public_path__ + "static/media/facebook-icon.c90d3f4b.svg";